var _title, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoFound = function SvgNoFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "no_found")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    rx: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807",
    transform: "translate(-1045.000000, -599.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no_found",
    transform: "translate(1045.000000, 599.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fillOpacity: 0,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    opacity: 0.4,
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#727272",
    points: "0 0 0 37.5847037 0.00577271062 37.5847037 0.00577271062 60 59.9942273 60 59.9942273 37.5847037 60 37.5847037 60 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#ABABAB",
    points: "0 0 0 24.4128836 0.00377446464 24.4128836 0.00377446464 38.9726017 38.9689051 38.9726017 38.9689051 24.4128836 38.9726795 24.4128836 38.9726795 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#ABABAB",
    points: "20.9274304 20.927308 20.9309828 59.9001317 59.8961134 59.9001317 59.8961134 45.3404136 59.8998879 45.3404136 59.8998879 20.927308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3955306,4.84714102 C33.8645633,4.84714102 42.351336,13.3339451 42.351336,23.8030166 C42.351336,27.652066 41.2042004,31.2331473 39.2331675,34.2230318 L55.7027942,50.692158 L50.591725,56.315465 L33.8795764,39.598389 C30.8768505,41.5954615 27.2720875,42.7591143 23.3955306,42.7591143 C12.9264979,42.7591143 4.4395031,34.2723101 4.4395031,23.8030166 C4.4395031,13.3339451 12.9264979,4.84714102 23.3955306,4.84714102 Z M23.3955084,12.5507186 C17.1809634,12.5507186 12.1431632,17.5885374 12.1431632,23.8031054 C12.1431632,30.0176734 17.1809634,35.0554922 23.3955084,35.0554922 C29.6100534,35.0554922 34.6478536,30.0176734 34.6478536,23.8031054 C34.6478536,17.5885374 29.6100534,12.5507186 23.3955084,12.5507186 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#444446"
  })))))));
};

export { SvgNoFound as ReactComponent };
export default __webpack_public_path__ + "5b36db186a1d9fe3f0fe75ad47939523.svg";